import { render, staticRenderFns } from "./AuthorizationBenefits.vue?vue&type=template&id=501b3c56&scoped=true&"
import script from "./AuthorizationBenefits.vue?vue&type=script&lang=js&"
export * from "./AuthorizationBenefits.vue?vue&type=script&lang=js&"
import style0 from "./AuthorizationBenefits.vue?vue&type=style&index=0&id=501b3c56&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "501b3c56",
  null
  
)

export default component.exports